import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@degenduel/ui/tokens.css";
import "@degenduel/ui/glass.css";
import "@degenduel/ui/arcade.css";
import "./app.css";
import { App } from "./App.js";
import { initSound } from "./sound.js";
import { initTelegram } from "./telegram.js";
import { reloadWhenUpdated } from "./update.js";
import { rememberOpenedChallenge } from "./challenge.js";

initTelegram();
rememberOpenedChallenge();
initSound();
reloadWhenUpdated();
if (import.meta.env.DEV) void import("./dev-overlay.js").then((m) => m.devTelegramOverlay());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
